import httpClient from "@plugins/http";
import { isEmpty } from "@utils/var.check";
import { ApiResponse } from "@apis/api.ts";

export default {
  approve: (params) => {
    return httpClient.post(`/apis/community-gallery/approve/${params.uuid}`);
  },
  reject: (uuid) => {
    return httpClient.post(`/apis/community-gallery/reject/${uuid}`);
  },
  unpublish: (params) => {
    return httpClient.post(`/apis/community-gallery/unpublish/${params.uuid}`);
  },
  // replace
  replace: (params) => {
    return httpClient.post(`/apis/community-gallery/replace/${params.uuid}`);
  },
  // treat as new
  promote: (params) => {
    return httpClient.post(`/apis/community-gallery/promote/${params.uuid}`);
  },
  checkIfSubmittable: (params): Promise<ApiResponse<Record<string, boolean>>> =>
    httpClient.get(`/apis/community-gallery/submittable/${params.type}/${params.uuid}`),

  submitLesson: (params) => {
    return httpClient.post(
      `/apis/community-gallery/submit/${params.type}/${params.uuid}`,
      params.requestData,
    );
  },
  resubmitLesson: (params) => {
    return httpClient.post(
      `/apis/community-gallery/resubmit/${params.type}/${params.uuid}`,
      params.requestData,
    );
  },
  fetchCGLesson: (params) => {
    return httpClient.get(`/apis/community-gallery/${params.isAdminAccess}/lesson/${params.uuid}`);
  },
  fetchResourceListing: (params) => {
    return httpClient.get(`/apis/community-gallery/list`, {
      params: params,
    });
  },
  fetchCGCreationStatus: (params) => {
    return httpClient.get(`/apis/community-gallery/creation-status/${params.uuid}`);
  },
  fetchCGUuidByResourceId: (params) => {
    return httpClient.get(
      `/apis/get/community-gallery/${params.resourceType}/${params.resourceUuid}`,
    );
  },
  fetchCGLessonContext: (uuid) => {
    return httpClient.get(`/apis/community-gallery/get-context/${uuid}`);
  },
  fetchCGDetails: ({ uuid, additionalDetails }) => {
    const params = {};
    if (!isEmpty(additionalDetails)) params.additionalDetails = additionalDetails;
    return httpClient.get(`/apis/community-gallery/get-details/${uuid}`, {
      params: params,
    });
  },
  deleteCG: (params) => {
    return httpClient.post(`/apis/community-gallery/delete/${params.uuid}`);
  },
};
